export default __webpack_public_path__ + "static/media/bobbleNeutral.529e44eb.svg";